/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ROUTE_PATHS } from '../constants';
import AppLoader from '../../common-components/AppLoader';
import { useAppDispatch, useAppSelector } from '../../helpers/hooks';
import { portalActions } from '../../layouts/MainLayout/slice';
import {
  selectBootstrapping,
  selectIsAuthenticated,
} from '../../layouts/MainLayout/slice/selectors';
import { getAuthToken } from '../../helpers/request';

interface AuthGuardProps {
  children: React.ReactNode;
}

export default function AuthGuard({
  children,
}: AuthGuardProps): React.ReactElement | null {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const bootstrapping = useAppSelector(selectBootstrapping);

  useEffect(() => {
    if (!getAuthToken()) {
      navigate(ROUTE_PATHS.LOGIN);
      return;
    }
    if (!isAuthenticated) {
      dispatch(portalActions.bootstrapRequest());
    }
  }, []);

  useEffect(() => {
    if (!bootstrapping && !isAuthenticated) {
      navigate(ROUTE_PATHS.LOGIN);
    }
  }, [bootstrapping, isAuthenticated]);

  if (!isAuthenticated) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <AppLoader />
      </Box>
    );
  }

  return <>{children}</>;
}
